import { endOfDay } from 'date-fns/endOfDay';
import { startOfDay } from 'date-fns/startOfDay';
import { subDays } from 'date-fns/subDays';

export enum TimeRangeType {
  ABSOLUTE = 'ABSOLUTE',
  RELATIVE = 'RELATIVE',
}

export type TimeRange = AbsoluteTimeRange | RelativeTimeRange;

export interface AbsoluteTimeRange {
  type: TimeRangeType.ABSOLUTE;
  from: Date;
  to: Date;
}

export interface RelativeTimeRange {
  type: TimeRangeType.RELATIVE;
  days: number;
  offsetInDays: number;
}

/**
 * Selection state for the explore time-range picker. It never crosses the API boundary: a relative
 * range is resolved to absolute `from`/`to` dates before it goes into `exploreQuerySchema`.
 */
export const TimeRangeUtils = {
  getFromDate(timeRange: TimeRange): Date {
    return timeRange.type === TimeRangeType.ABSOLUTE
      ? timeRange.from
      : startOfDay(subDays(new Date(), timeRange.offsetInDays + timeRange.days - 1));
  },
  getToDate(timeRange: TimeRange): Date {
    return timeRange.type === TimeRangeType.ABSOLUTE
      ? timeRange.to
      : endOfDay(subDays(new Date(), timeRange.offsetInDays));
  },
  isAbsolute(timeRange: TimeRange): timeRange is AbsoluteTimeRange {
    return timeRange.type === 'ABSOLUTE';
  },
  isRelative(timeRange: TimeRange): timeRange is RelativeTimeRange {
    return timeRange.type === 'RELATIVE';
  },
  today(): RelativeTimeRange {
    return {
      type: TimeRangeType.RELATIVE,
      days: 1,
      offsetInDays: 0,
    };
  },
  yesterday(): RelativeTimeRange {
    return {
      type: TimeRangeType.RELATIVE,
      days: 1,
      offsetInDays: 1,
    };
  },
  lastWeek(): RelativeTimeRange {
    return {
      type: TimeRangeType.RELATIVE,
      days: 7,
      offsetInDays: 1,
    };
  },
  lastMonth(): RelativeTimeRange {
    return {
      type: TimeRangeType.RELATIVE,
      days: 30,
      offsetInDays: 1,
    };
  },
};
